import HostedCheckout from "./HostedCheckout";

/**
 * School-fees installment payment through CIB Hosted Checkout.
 * Used by the School Fees page (src/components/Parent/Schoolfees.tsx).
 */

interface Props {
  /** EGP to pay now; may be less than the installment balance. */
  amount: number;
  /** Installment row from the `installments` view. */
  installment: any;
  onFinish: (result: any) => void;
  /** Ignored - kept so existing callers still type-check. */
  code?: string;
}

export default function PayInstallment({ amount, installment, onFinish }: Props) {
  return (
    <HostedCheckout
      endpoint="payment/installment/createsession.php"
      payload={{ ...installment, paidamount: amount }}
      onFinish={onFinish}
    />
  );
}
